import { useTranslation } from 'react-i18n-lite'
import {
  Icon,
  SafeHtmlContent,
  isEmbedded
} from '@yes.technology/react-toolkit'

import { useIsOpen } from 'shared/hooks'
import {
  AnimatedMessage,
  ComponentStructure,
  IconButton
} from './EnvironmentAlert.styles'
import { EnvironmentAlertProps } from './EnvironmentAlert.types'
import { DANGER_ENVIRONMENTS } from './EnvironmentAlert.consts'

const EnvironmentAlert = ({ environment }: EnvironmentAlertProps) => {
  const { isOpen, close } = useIsOpen(true)
  const { t } = useTranslation()

  if (!environment) return null

  const isProductionEnv = environment === 'production'

  if (isEmbedded() || !isOpen || isProductionEnv) return null

  const isEnvironmentDanger = DANGER_ENVIRONMENTS.some((dangerEnv) =>
    environment.includes(dangerEnv)
  )

  const message = isEnvironmentDanger
    ? t('system.danger-env', { environment })
    : t('system.warning-env', { environment })

  return (
    <ComponentStructure isEnvironmentDanger={isEnvironmentDanger}>
      <AnimatedMessage isEnvironmentDanger={isEnvironmentDanger}>
        <SafeHtmlContent html={message} />
      </AnimatedMessage>
      {!isEnvironmentDanger && (
        <IconButton onClick={close}>
          <Icon iconName='Close' icSize='small' />
        </IconButton>
      )}
    </ComponentStructure>
  )
}

export default EnvironmentAlert
